<ng-container *ifPrivilege="{name: 'read', value: 'code-snippets'}">
  <div class="available">
    <h3>Available</h3>
    <data-table
      (detail)="assignImport($event)"
      [columns]="columns"
      [dataProviderParams]="params"
      [dataProvider]="codeSnippetService">
    </data-table>
  </div>

  <div class="assigned">
    <h3>Assigned</h3>
    <data-table
      #assignedCodeSnippetsTable
      (remove)="removeAssignedCodeSnippet($event)"
      [columns]="columns"
      [dataProvider]="assignedCodeSnippetsProvider">
    </data-table>
  </div>
</ng-container>
